import React from "react";
import DigitalWallet from "../components/DigitalWallet/DigitalWallet";

export default function DigitalWalletView() {
  return <DigitalWallet />;
}
